/* Petmarlow small behaviours: video pause control, reduced motion, delivery estimate,
   flash sale countdowns and the best seller pop-up. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initVideos(root) {
    (root || document).querySelectorAll('[data-pm-video]').forEach(function (wrap) {
      if (wrap.dataset.pmReady) return;
      wrap.dataset.pmReady = '1';
      var video = wrap.querySelector('video');
      var btn = wrap.querySelector('[data-pm-video-toggle]');
      if (!video) return;
      video.muted = true;
      video.setAttribute('playsinline', '');
      video.removeAttribute('controls');
      function setState(paused) {
        if (!btn) return;
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.setAttribute('aria-label', paused ? btn.dataset.labelPlay : btn.dataset.labelPause);
      }
      if (reduce) {
        video.removeAttribute('autoplay');
        video.pause();
        setState(true);
      } else {
        var tryPlay = function () {
          if (wrap.dataset.pmUserPaused) return;
          var p = video.play();
          if (p && p.then) p.then(function () { setState(false); }).catch(function () { setState(true); });
        };
        tryPlay();
        /* Some browsers refuse autoplay while the tab is in the background: retry when it becomes visible or on first interaction. */
        var retry = function () { if (video.paused) tryPlay(); };
        document.addEventListener('visibilitychange', function () { if (!document.hidden) retry(); });
        ['pointerdown', 'touchstart', 'scroll', 'keydown'].forEach(function (ev) {
          window.addEventListener(ev, retry, { once: true, passive: true });
        });
      }
      if (btn) {
        btn.addEventListener('click', function () {
          if (video.paused) { delete wrap.dataset.pmUserPaused; video.play(); setState(false); }
          else { wrap.dataset.pmUserPaused = '1'; video.pause(); setState(true); }
        });
      }
    });
  }

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }

  function initEta(root) {
    (root || document).querySelectorAll('[data-pm-eta]').forEach(function (el) {
      var min = parseInt(el.dataset.min || '4', 10);
      var max = parseInt(el.dataset.max || '10', 10);
      var now = new Date();
      var fmt = { month: 'short', day: 'numeric' };
      var from = addBusinessDays(now, min).toLocaleDateString('en-US', fmt);
      var to = addBusinessDays(now, max).toLocaleDateString('en-US', fmt);
      el.textContent = from + ' – ' + to;
    });
  }

  function initTimeline(root) {
    (root || document).querySelectorAll('[data-pm-timeline]').forEach(function (el) {
      var pMin = parseInt(el.dataset.procMin || '1', 10), pMax = parseInt(el.dataset.procMax || '3', 10);
      var tMin = parseInt(el.dataset.transitMin || '7', 10), tMax = parseInt(el.dataset.transitMax || '12', 10);
      var now = new Date();
      var fmt = { month: 'short', day: 'numeric' };
      function span(a, b) { return addBusinessDays(now, a).toLocaleDateString('en-US', fmt) + ' – ' + addBusinessDays(now, b).toLocaleDateString('en-US', fmt); }
      var o = el.querySelector('[data-pm-tl="ordered"]'); if (o) o.textContent = now.toLocaleDateString('en-US', fmt);
      var d = el.querySelector('[data-pm-tl="dispatched"]'); if (d) d.textContent = span(pMin, pMax);
      var v = el.querySelector('[data-pm-tl="delivered"]'); if (v) v.textContent = span(pMin + tMin, pMax + tMax);
    });
  }

  /* ---------- countdowns (flash sale) ---------- */
  var countdowns = [];
  var clock = null;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var now = Date.now();
    countdowns.forEach(function (el) {
      var left = Math.floor((parseInt(el.dataset.end, 10) * 1000 - now) / 1000);
      if (left <= 0) {
        var root = el.closest('[data-pm-flash-root]');
        if (root) root.hidden = true;
        return;
      }
      var d = Math.floor(left / 86400); left -= d * 86400;
      var h = Math.floor(left / 3600); left -= h * 3600;
      var m = Math.floor(left / 60); var sec = left - m * 60;
      var map = { d: pad(d), h: pad(h), m: pad(m), s: pad(sec) };
      el.querySelectorAll('[data-u]').forEach(function (u) {
        var v = map[u.dataset.u];
        if (u.textContent !== v) u.textContent = v;
      });
    });
  }
  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-pm-countdown]').forEach(function (el) {
      if (el.dataset.pmReady) return;
      el.dataset.pmReady = '1';
      countdowns.push(el);
      var sr = el.parentNode && el.parentNode.querySelector('[data-pm-ends]');
      if (sr) {
        var end = new Date(parseInt(el.dataset.end, 10) * 1000);
        sr.textContent = 'Sale ends ' + end.toLocaleString('en-US', { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }) + '.';
      }
    });
    if (countdowns.length) {
      tick();
      if (!clock) clock = setInterval(tick, 1000);
    }
  }

  /* ---------- best seller pop-up ---------- */
  function initPopup() {
    var box = document.getElementById('PmPopup');
    if (!box || box.dataset.pmReady) return;
    box.dataset.pmReady = '1';
    var items = Array.prototype.slice.call(box.querySelectorAll('[data-pm-popup-items] li'));
    if (!items.length) return;
    try { if (window.sessionStorage.getItem('pm-popup-off')) return; } catch (e) {}

    var link = box.querySelector('[data-pm-popup-link]');
    var img = box.querySelector('[data-pm-popup-img]');
    var title = box.querySelector('[data-pm-popup-title]');
    var price = box.querySelector('[data-pm-popup-price]');
    var closeBtn = box.querySelector('[data-pm-popup-close]');
    var delay = (parseInt(box.dataset.delay, 10) || 8) * 1000;
    var show = (parseInt(box.dataset.show, 10) || 7) * 1000;
    var gap = (parseInt(box.dataset.gap, 10) || 14) * 1000;
    var i = Math.floor(Math.random() * items.length);
    var shown = 0, maxShows = 10, timer = null, hovering = false;

    function fill(li) {
      link.href = li.dataset.u;
      img.src = li.dataset.i;
      img.alt = li.dataset.a || '';
      title.textContent = li.dataset.t;
      price.textContent = li.dataset.p;
    }
    function open() {
      if (document.hidden || document.querySelector('dialog[open]')) { timer = setTimeout(open, 4000); return; }
      fill(items[i % items.length]);
      i++; shown++;
      box.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { box.classList.add('is-open'); }); });
      timer = setTimeout(close, show);
    }
    function close() {
      if (hovering) { timer = setTimeout(close, 2000); return; }
      box.classList.remove('is-open');
      setTimeout(function () { if (!box.classList.contains('is-open')) box.hidden = true; }, 350);
      if (shown < maxShows) timer = setTimeout(open, gap);
    }
    box.addEventListener('mouseenter', function () { hovering = true; });
    box.addEventListener('mouseleave', function () { hovering = false; });
    box.addEventListener('focusin', function () { hovering = true; });
    box.addEventListener('focusout', function () { hovering = false; });
    closeBtn.addEventListener('click', function () {
      clearTimeout(timer);
      box.classList.remove('is-open');
      box.hidden = true;
      try { window.sessionStorage.setItem('pm-popup-off', '1'); } catch (e) {}
    });
    timer = setTimeout(open, delay);
  }

  /* ---------- footer menus collapse on phones ---------- */
  function initFooter(root) {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    (root || document).querySelectorAll('[data-pm-footer-acc]').forEach(function (d) {
      if (d.dataset.pmReady) return;
      d.dataset.pmReady = '1';
      d.removeAttribute('open');
    });
  }

  function init(root) { initVideos(root); initEta(root); initTimeline(root); initCountdowns(root); initPopup(); initFooter(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
